import classNames from 'classnames'
import PencilIcon from 'mdi-react/PencilIcon'
import React from 'react'
import SubmitButton from 'scenes/Dashboard/components/SubmitButton'

import { Button, IconButton } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import styles from './PersonFormFooter.style'

class PersonFormFooter extends React.Component<PersonFormFooterProps & WithStyles<typeof styles>> {
  render() {
    const {
      classes,
      className,
      onSave,
      onBack,
      onEdit,
      isInEditMode,
      isInNewMode = false,
      isSubmitting = false,
    } = this.props

    // We have to type-cast here because TypeScript seems unable to infer
    // the right type by itself.
    const containerClass = classNames(classes.peopleActionsContainer, className, {
      [classes.peopleActionsContainerNoUser]: isInNewMode,
    })

    return (
      <div className={containerClass}>
        {isInEditMode ? (
          <div className={classes.editActions}>
            <Button variant="text" size="medium" className={classes.backButton} onClick={onBack}>
              Discard
            </Button>
            <SubmitButton label="Save" submitting={isSubmitting} onClick={onSave} />
          </div>
        ) : (
          <IconButton onClick={onEdit}>
            <PencilIcon />
          </IconButton>
        )}
      </div>
    )
  }
}

export type PersonFormFooterProps = {
  className: string
  isSubmitting?: boolean
  isInNewMode: boolean
  isInEditMode: boolean
  onSave: () => void
  onBack: () => void
  onEdit: () => void
  onDelete: () => void
}

export default withStyles(styles)(PersonFormFooter)
